export function parallax() {
  window.addEventListener('scroll', function () {
    const scrollPosition = window.scrollY;
    const parallaxElement = document.querySelector('.js-parallax');

    // スクロール量に応じて background-position-y を調整
    parallaxElement.style.backgroundPositionY = `${50 + scrollPosition * 0.02}%`;
  });
}
